
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { hexToRgba } from '@/utils';
export default defineComponent({
  name: 'Message',
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ]),
    successColor (): string {
      return this.global.successColor || '#337E33';
    },
    successBackgroundColor (): string {
      return hexToRgba(this.successColor, 0.15);
    }
  }
});
